var map = {
	"./BAT-logo.png": 536,
	"./BUSD-logo.png": 537,
	"./COMP-logo.png": 538,
	"./CRV-logo.png": 539,
	"./DAI-logo.png": 540,
	"./ETH-logo.png": 541,
	"./FTM-logo.png": 542,
	"./KNC-logo.png": 543,
	"./LEND-logo.png": 544,
	"./LINK-logo.png": 545,
	"./MANA-logo.png": 546,
	"./MKR-logo.png": 547,
	"./REP-logo.png": 548,
	"./SAI-logo.png": 549,
	"./SNX-logo.png": 550,
	"./SUSD-logo.png": 551,
	"./TUSD-logo.png": 326,
	"./USDC-logo.png": 552,
	"./USDT-logo.png": 553,
	"./WETH-logo.png": 554,
	"./YFI-logo.png": 184,
	"./ZRX-logo.png": 555,
	"./aLINK-logo.png": 556,
	"./cUSDC-logo.png": 557,
	"./cUSDT-logo.png": 558,
	"./crvBTC-logo.png": 559,
	"./crvBUSD-logo.png": 560,
	"./iDAI-logo.png": 561,
	"./wBTC-logo.png": 562,
	"./yCRV-logo.png": 563,
	"./ycUSDC-logo.png": 564,
	"./ycUSDT-logo.png": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;